import React from 'react';
import aboutUsImage from '../../Images/aboutUsImage.png';
import "./styles.css";

const AboutUs = () => {


    return (
        <div className="aboutUs">
            <img src={aboutUsImage} alt="not found"/>
        </div>
    );
}

export default AboutUs
